import { Box, Button, Card, Chip, CardContent, Divider, Grid, TextField, Typography, MenuItem, IconButton, Snackbar } from '@mui/material'
import React, { useEffect, useState, useContext } from 'react';
import { fetchToken, fetchRole } from '../auth/Token';
import AuthContext from "../auth/AuthProvider";
import { api } from '../api';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import  CloseIcon  from '@mui/icons-material/Close';
import { toast } from 'sonner';


const AssociationDetails = (props) => {
    const [error, setError] = useState("");
    const [updateForm, setUpdateForm] = useState("");
    const [infoma, setInfoma] = useState([]);
    const id = props.id
    const [ope, setOpe] = React.useState(false);
    const {  permissions } = useContext(AuthContext);
    const [message, setMessage] = useState("");

    const handleClo = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setOpe(false);
    };

    const viewUr = (url) => {
        if(url){
            window.open(url, '_blank');
        }else{
            toast.warning("Address is not available");
        }
    };

    const actio = (
        <React.Fragment>
          <Button color="secondary" size="small" onClick={handleClo}>
            CLOSE
          </Button>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClo}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </React.Fragment>
      );
        
        
    

    const formik = useFormik({
            initialValues: {
            "association_name": `${props.nyoma.Association_name}`,
            "community_name": `${props.nyoma.community_name}`,
            "cluster_office": `${props.nyoma.cluster_office}`,
            "association_email": `${props.nyoma.association_email}`,
            "facilitator_userid": `${props.nyoma.Facilitator_id}`,
            "staff_userid": `${props.nyoma.Staff_id}`,
            "location": `${props.nyoma.location}`,
            "merchant_line": `${props.nyoma.merchant_line}`,
            "association_type_id": `${props.nyoma.Association_type_id}`,
            "created_by": `${props.nyoma.Created_by}`,
            "open_date": `${props.nyoma.open_date}` !== 'null'?`${props.nyoma.open_date}`: '',
        },
        validationSchema: Yup.object({
            "association_name": Yup.string().required("This should not be empty"),
            "association_email": Yup.string().email('Should be a valid email').required('Required'),
        }),
        onSubmit: (values) => {
        try{
            api.put(`association/${id}`, values,{
                headers :{
                Authorization: 'Bearer '+ fetchToken(),
                'Content-Type': 'application/json',
                }
            }).then(function (response){
                toast.success(response.data);
                props.details();
            }).catch(function (error){
                console.log(error)
            });
        
        } catch(error){
            console.log(error.response.data.detail[0])
        };
            }
        });



    useEffect(() => {
        const form = async () => {
            try {
                  const response = await api.get('/association/form/data',{
                    headers :{
                        Authorization: 'Bearer '+ fetchToken()
                        }
                  })
                    setInfoma(response.data)
                   
                } catch (error) {
                    console.log('This is that error', error )
                }
            }

            form();
    },[])


    

    
    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long' };
        const date = new Date(dateString);
        
        const day = date.getDate();
        const dayStr = day + (day % 10 === 1 && day !== 11 ? 'st' : day % 10 === 2 && day !== 12 ? 'nd' : day % 10 === 3 && day !== 13 ? 'rd' : 'th');
        
        const formattedDate = date.toLocaleDateString(undefined, options);
        
        return `${dayStr} ${formattedDate}`;
    }

    

    const Update = () => {
        setUpdateForm(
            <div>
                <form onSubmit={formik.handleSubmit}>
                <Box>
                    <TextField
                        required
                        sx={{ marginBottom:2 }}
                        type='text'
                        label='Savings Group name'
                        name='association_name'
                        defaultValue={formik.values.association_name}
                        id='association_name'
                        onChange={formik.handleChange}
                        variant='standard'
                        fullWidth
                    />
                    <TextField
                        required
                        sx={{ marginBottom:2 }}
                        type='text'
                        label='Community name'
                        id='community_name'
                        name='community_name'
                        onChange={formik.handleChange}
                        variant='standard'
                        fullWidth
                        defaultValue={formik.values.community_name}
                    />
                    <TextField
                        required
                        sx={{ marginBottom:2 }}
                        type='text'
                        label='Cluster Office'
                        name='cluster_office'
                        id='cluster_office'
                        onChange={formik.handleChange}
                        variant='standard'
                        fullWidth
                        defaultValue={formik.values.cluster_office}
                    />
                    <TextField
                        required
                        sx={{ marginBottom:2 }}
                        type='email'
                        label='Savings Group Email'
                        onChange={formik.handleChange}
                        name='association_email'
                        id='association_email'
                        variant='standard'
                        fullWidth
                        defaultValue={formik.values.association_email}
                    />
                    
                    <TextField
                        sx={{ marginBottom:2 }}
                        label='Savings Group Merchant Line'
                        onChange={formik.handleChange}
                        name='merchant_line'
                        id='merchant_line'
                        variant='standard'
                        fullWidth
                        defaultValue={formik.values.merchant_line}
                    />
                    
                    <TextField
                        sx={{ marginBottom:2 }}
                        label='Savings Group Location (link)'
                        onChange={formik.handleChange}
                        name='location'
                        id='location'
                        variant='standard'
                        fullWidth
                        defaultValue={formik.values.location}
                    />
                    <TextField
                        sx={{ marginBottom:2 }}
                        id="facilitator_userid"
                        select
                        onChange={formik.handleChange}
                        label="Facilitator"
                        fullWidth
                        name='facilitator_userid'
                        defaultValue={formik.values.facilitator_userid}
                        helperText="Update the Facilitator"
                        // value={formData.facilitator_userid}
                        variant="standard"
                        >
                        {infoma[1].facilitator?.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                            {item.username}
                            </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        sx={{ marginBottom:2 }}
                        id="staff_userid"
                        select
                        label="Assign Staff"
                        onChange={formik.handleChange}
                        fullWidth
                        name='staff_userid'
                        defaultValue={formik.values.staff_userid}
                        helperText="Assign different staff"
                        // value={formData.Facilitator_id}
                        variant="standard"
                        >
                        {infoma[1].facilitator?.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                            {item.username}
                            </MenuItem>
                        ))}
                    </TextField>
                </Box>
                <Button sx={{ marginTop: 1, marginRight:1 }} variant='outlined' onClick={closeForm}>Close</Button>
                <Button sx={{ marginTop: 1 }} variant='outlined' type="submit" >Save</Button>
                </form>
            
                
            </div>
        )
    };

    const closeForm = () => {
        setUpdateForm("")
    };

    // const saveUpdate = async (event) => {
    //     event.preventDefault();
    //     console.log(formik.values)
        // console.log(formData);
        // try{
        //     api.put(`association/${id}`, formData,{
        //         headers :{
        //         Authorization: 'Bearer '+ fetchToken()
        //         }
        //     }).then(function (response){
        //         console.log(response.data);
        //         setFormData({
        //             "association_name": data.Association_name,
        //             "community_name": data.community_name,
        //             "cluster_office": data.cluster_office,
        //             "association_email": data.association_email,
        //             "facilitator_userid":  data.Facilitator_id,
        //             "staff_userid": data.Staff_id,
        //             "association_type_id": data.Association_type_id,
        //             "created_by": data.Created_by,
        //             "open_date": data.open_date,
        //         });
        //     });
        
        // } catch(error){
            // setError("Opps seems like there's an error with our server, Please hold on tithe whiles we fix it")
        //     console.log('This is that error', error )
        // };
    // }
    
   
  return (
    <div>
        <Card variant='soft' sx={{ minWidth: 275, border: 1 }}>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item md={6}>
                        <Typography>
                        <h3>Savings Group Name: <span style={{ color:'blue' }}>  {props.name} {props.type}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Facilitator: <span style={{ color:'#611717' }}>{props.nyoma.Facilitator_username}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Community: <span style={{ color:'#611717' }}> {props.nyoma.community_name}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Merchant Line: <span style={{ color:'#611717' }}> {props.nyoma.merchant_line}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Location: <Chip 
                                                                                                size='small'
                                                                                                label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Map</b></Typography>}
                                                                                                sx={{
                                                                                                    borderRadius: 2,
                                                                                                    m: 1,
                                                                                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                                                                                    backgroundColor: '#2b2d42',
                                                                                                    color: '#fff',
                                                                                                    '&:hover': {
                                                                                                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                                                                    backgroundColor: '#14213d',
                                                                                                    },
                                                                                                }} 
                                                                                                onClick={() => viewUr(props.nyoma.location)} 
                                                                                            /></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Assigned Staff: <span style={{ color:'#611717' }}> {props.nyoma.Staff_Assigned_username}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Total Members: <span style={{ color:'#611717' }}> {props.nyoma.Members?.length || 0}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Date Registered: <span style={{ color: '#611717' }}> {formatDate(props.nyoma.open_date)}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Cluster Office: <span style={{ color: '#611717' }}> {props.nyoma.cluster_office}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Savings Group Email: <span style={{ color: '#611717' }}> {props.nyoma.association_email}</span></h3>
                        </Typography>
                        <Divider variant="middle"></Divider>
                        <Typography>
                            <h3>Created by: <span style={{ color: '#611717' }}> {props.nyoma.Created_by_username}</span></h3>
                        </Typography>
                        {
                            permissions && permissions.update_association === true ?
                            <Button variant='outlined' onClick={Update}>Update</Button>
                            : 
                            null
                        }
                        {
                            permissions && permissions.delete_association === true ?
                            <Button sx={{ marginLeft: 1 }} variant='outlined'>Delete</Button>
                            :
                            null
                        }
                        
                    </Grid>
                    <Grid item md={6}>
                        {updateForm}
                    </Grid>
                    <Snackbar
                        open={ope}
                        autoHideDuration={6000}
                        onClose={handleClo}
                        message={message}
                        action={actio}
                    />
                </Grid>        
            </CardContent>
        </Card>
    </div>
  )
}

export default AssociationDetails